const replaceAt = <ArrayElement>(source: ArrayElement[], index: number, element: ArrayElement): ArrayElement[] => {
  return [...source.slice(0, index), element, ...source.slice(index + 1)];
};

export default replaceAt;
